<template>
  <v-dialog v-model="newUserDialog" max-width="1200px">
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Bank Approve</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>
      <v-layout
        row
        wrap
        style="padding: 10px"
        justify-space-around
        v-if="setBankById != null"
      >
        <v-flex xs12 sm5>
          <p>Full Name(TH)</p>
          <v-text-field
            disabled
            :placeholder="setBankById.bank_manager_customer_name"
            outline
          ></v-text-field>
          <p>Bank Name(TH)</p>
          <v-text-field
            disabled
            outline
            :placeholder="setBankById.bank_manager_bank.bank_name_th"
          ></v-text-field>
          <div style="display: flex; justify-content: center">
            <img
              class="img"
              :style="{
                width: this.$vuetify.breakpoint.xs ? '300px' : null,
              }"
              :src="setBankById.bank_manager_image_customer_id_card"
              @click="
                dialogFunction(setBankById.bank_manager_image_customer_id_card)
              "
            />
          </div>
        </v-flex>
        <v-flex xs12 sm5>
          <p>Bank Number</p>
          <v-text-field
            disabled
            outline
            :placeholder="setBankById.bank_manager_bank_number"
          ></v-text-field>
          <p>ID Card</p>
          <v-text-field
            disabled
            outline
            :placeholder="setBankById.bank_manager_customer_id_card"
          ></v-text-field>
          <div style="display: flex; justify-content: center;">
            <img
              class="img"
              :style="{
                width: this.$vuetify.breakpoint.xs ? '300px' : null,
              }"
              :src="setBankById.bank_manager_image_book_bank"
              @click="dialogFunction(setBankById.bank_manager_image_book_bank)"
            />
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mx-4"></v-divider>
      <div style="display: flex; justify-content: center" v-if="button">
        <v-btn
          flat
          large
          color="error"
          @click.stop="(dialog = true), (textReject = true)"
          >REJECT</v-btn
        >
        <v-btn
          flat
          large
          color="success"
          @click.stop="(dialog = true), (textApprove = true)"
          >APPROVE</v-btn
        >
      </div>
      <div style="display: flex; justify-content: center" v-if="buttonDelete">
        <v-btn
          flat
          large
          color="error"
          @click.stop="(dialog = true), (textDelete = true)"
          >DELETE</v-btn
        >
      </div>
    </v-card>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" max-width="500">
        <v-card style="border-radius: 10px">
          <v-card-title class="px-4"
            ><h2>
              {{
                textReject
                  ? "Do you want to Reject this bank?"
                  : textApprove
                  ? "Do you want to Approve this bank"
                  : textDelete
                  ? "Do you want to Delete this bank?"
                  : null
              }}
            </h2>
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap style="padding: 15px">
              <v-flex xs12 sm20>
                <v-text-field
                  :rules="[(v) => !!v || 'Required']"
                  v-if="textReject"
                  v-model="textRemark"
                  placeholder="Remark"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-card-actions class="pr-5 py-4">
            <v-spacer></v-spacer>
            <v-btn
              flat
              dark
              color="red"
              style="
                width: 120px;
                border-radius: 7px;
                font-weight: bold;
                font-size: 16px;
              "
              @click="
                (dialog = false),
                  (textReject = false),
                  (textApprove = false),
                  (textDelete = false),
                  (textRemark = null)
              "
              :loading="btnLoading"
              >cancel</v-btn
            >
            <v-btn
              flat
              dark
              color="black"
              style="
                width: 120px;
                background-color: #fddf00;
                border-radius: 7px;
                font-weight: bold;
                font-size: 16px;
              "
              @click="
                {
                  {
                    textDelete
                      ? deleteItem(setBankById.bank_manager_id)
                      : textReject
                      ? rejectbank(setBankById.bank_manager_id)
                      : textApprove
                      ? approveBank(setBankById.bank_manager_id)
                      : null;
                  }
                }
              "
              :loading="btnLoading"
              >confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        v-model="dialogImg"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
      >
        <v-toolbar dark color="primary">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImg = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card
          style="display: flex; justify-content: center; background-color: aliceblue;"
        >
          <img
            style="margin-top: 45px;"
            :src="preview"
            :style="{
              width: this.$vuetify.breakpoint.xs ? '300px' : '1000px',
              height: this.$vuetify.breakpoint.xs ? '400px' : '800px',
            }"
          />
        </v-card>
      </v-dialog>
    </v-layout>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog", "button", "buttonDelete"],
  data() {
    return {
      dialog: false,
      dialogImg: false,
      preview: "",
      valid: true,
      selectedItem: {},
      btnLoading: false,
      textReject: false,
      textApprove: false,
      textDelete: false,
      textRemark: "",
    };
  },
  computed: {
    ...mapState({
      setBankById: (state) => state.banklist.setBankById,
      bankListData: (state) => state.banklist.setStatus,
      bankListApprove: (state) => state.banklist.setStatusBankApprove,
    }),
  },
  methods: {
    toDeleteItem(item) {
      this.deleteDialog = true;
      this.selectedItem = item;
    },
    dialogFunction(img) {
      this.dialogImg = true;
      this.preview = img;
    },
    async deleteItem(item) {
      this.isDeleting = true;
      this.btnLoading = true;
      let result = await this.$store.dispatch(
        "banklist/deleteBankManagerBackoffice",
        item
      );
      this.isDeleting = false;
      this.btnLoading = false;
      if (result == false) return;
      let index = this.bankListData.findIndex(
        (val) => val.bank_manager_id == this.selectedItem.bank_manager_id
      );
      this.bankListData.splice(index, 1);
      await this.$store.dispatch("banklist/GetCountApproveBank");
      this.deleteDialog = false;
      this.dialog = false;
      this.isAdding = true;
      let _this = this;
      (this.textReject = false),
        (this.textApprove = false),
        (this.textDelete = false),
        this.$emit("onSaved", {
          done() {
            _this.isAdding = false;
          },
        });
    },
    async approveBank(item) {
      this.isDeleting = true;
      let result = await this.$store.dispatch(
        "banklist/ApproveBankManager",
        item
      );
      if (result == false) return;
      await this.$store.dispatch("banklist/fetchBanklistApprove");
      await this.$store.dispatch("banklist/GetCountApproveBank");
      this.deleteDialog = false;
      this.dialog = false;
      this.isAdding = true;
      let _this = this;
      this.$emit("onSaved", {
        done() {
          _this.isAdding = false;
        },
      });
    },
    async rejectbank(item) {
      if (this.$refs.form.validate(item)) {
        const payload = {
          id: item,
          remark: this.textRemark,
        };
        this.isDeleting = true;
        this.btnLoading = true;
        let result = await this.$store.dispatch("banklist/RejectBankManager", {
          payload,
        });
        if (result == false) return;
        await this.$store.dispatch("banklist/GetCountApproveBank");
        let index = this.bankListApprove.findIndex(
          (val) => val.bank_manager_id == this.item
        );
        this.bankListApprove.splice(index, 1);
        this.isDeleting = false;
        this.deleteDialog = false;
        this.dialog = false;
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          done() {
            _this.isAdding = false;
          },
        });
      }
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
.img {
  cursor: pointer;
}
</style>
